let ACCOUNT: any = {};
ACCOUNT.WAGES = '425866854';
ACCOUNT.EXPENSES = '442829529';
ACCOUNT.G72EXPENSES = '205386517';
ACCOUNT.REVENUE = '480004229';
ACCOUNT.G72REVENUE = '078086297';
ACCOUNT.CASH_REVENUE = '495280120';
ACCOUNT.SQUARE_REVENUE = '495280120';
ACCOUNT.EBAY_REVENUE = '454000371';
ACCOUNT.BAS = '453450661';
ACCOUNT.RENT = '426179837';
ACCOUNT.SUPER = '426179757';

export { ACCOUNT }